<template>
  <div class="list" name="add">
    <el-card>
      <el-col>
        <el-form
          label-position="left"
          style="margin-top: 20px;"
          label-width="130px"
          :model="addForm"
          :rules="rule_data"
          ref="addForm"
        >
          <el-row style="height: 60px;">
            <el-col :span="1.5">
              <auth-button
                opt="batch_import"
                :plain="true"
                size="small"
                class="check"
                @click.native="showBatch()"
                label="批量导入"></auth-button>
            </el-col>
          </el-row>

          <el-form-item label="机具编号" prop="FSn">
            <el-input
              class="form-input"
              v-model="addForm.FSn"
              placeholder="请输入机具编号，最长20位"
              :maxLength="20"
            ></el-input>
          </el-form-item>

          <el-form-item label="返回配件" prop="FComponents">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="componentCheckAll"
              @change="handleComponentCheckAllChange"
            >全选</el-checkbox>
            <el-checkbox-group v-model="addForm.FComponents" @change="handleComponentCheckedChange">
              <el-checkbox label="1">数据线</el-checkbox>
              <el-checkbox label="2">电源适配器</el-checkbox>
              <el-checkbox label="3">包装盒</el-checkbox>
              <el-checkbox label="4">说明书</el-checkbox>
              <el-checkbox label="6">裸机</el-checkbox>
              <el-checkbox label="7">电池</el-checkbox>
              <el-checkbox label="5">
                其他
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-if="addForm.FComponents.includes('5')"
                  v-model="addForm.FComponentsRemark"
                ></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="是否解绑" prop="FIsUnbind">
            <el-radio-group v-model="addForm.FIsUnbind">
              <el-radio label="0">不解绑</el-radio>
              <el-radio label="1">解绑</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="返修原因" prop="FReworkAgent">
            <el-input
              class="form-input"
              type="textarea"
              v-model="addForm.FReworkAgent"
              placeholder="请输入返修原因"
            ></el-input>
          </el-form-item>

          <el-form-item ref label="照片补充原因" prop="fAgentUrl">
            <el-form label-width="120px" ref="picForm">
              <div class="photos-content-view">
                <div>
                  <VueImgInputer
                    v-model="addForm.fAgentUrl"
                    theme="material"
                    size="normal"
                    v-loading="picLoadingArr.fAgentUrlShow"
                    :imgSrc="addForm.fAgentUrlShow"
                    @onChange="upload('fAgentUrl')"
                    :max-size="picMaxSize"
                    class="imgPad img1"
                  ></VueImgInputer>
                </div>
              </div>
            </el-form>
          </el-form-item>

          <el-form-item label="快递编号" prop="FAgentExpressNo">
            <el-input class="form-input" v-model="addForm.FAgentExpressNo" placeholder="请输入快递编号"></el-input>
          </el-form-item>

          <el-form-item label="收件人(寄回)" prop="FReceiveName">
            <el-input class="form-input" v-model="addForm.FReceiveName" placeholder="请输入收件人名称"></el-input>
          </el-form-item>

          <el-form-item label="联系方式" prop="FReceiveMobile">
            <el-input class="form-input" v-model="addForm.FReceiveMobile" placeholder="请输入联系方式"></el-input>
          </el-form-item>

          <el-form-item label="寄回地址" prop="FReceiveAddress">
            <el-input
              class="form-input"
              v-model="addForm.FReceiveAddress"
              type="textarea"
              placeholder="请输入寄回地址"
            ></el-input>
          </el-form-item>
        </el-form>
        <auth-button
          opt="submit"
          icon="el-icon-circle-plus-outline"
          @click.native="addSubmit('addForm')"
          :loading="addLoading"
          label="提交"></auth-button>
      </el-col>
    </el-card>

    <!-- 批量录入界面 -->
    <el-dialog title :visible.sync="dialogVisible" size="small" width="35%">
      <form
        action="${path}/agent-rework/batch-importSnRepair.do"
        id="importExpress"
        enctype="multipart/form-data"
        method="post"
      >
        <table cellspacing="10">
          <tr>
            <td colspan="2" align="left">
              <span style="font-weight:bold;">导入文件：</span>
              <input type="file" name="importOrder" id="importOrder" @change="getFile($event)" />
            </td>
          </tr>
          <tr>
            <td colspan="2" align="left">
              <a
                style="font-weight:bold;color:red"
                href="https://y.yeahka.com/jjb/sn_template2.xlsx"
              >点击下载新模板sn_template2</a>
            </td>
          </tr>
        </table>
      </form>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button id="importOrderId" @click="batchSubmit()">导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import VueImgInputer from 'vue-img-inputer'
import { uploadPic } from '@/api/global'
import { addreworkMachine, batchAddRework } from '@/api/machine'
const componentCheckOptions = ['1', '2', '3', '4', '6', '7', '5']

export default {
  components: {
    VueImgInputer
  },
  data () {
    return {
      // 新增界面数据
      addForm: {
        FSn: '',
        FComponents: [],
        FComponentsRemark: '',
        FIsUnbind: '0',
        FReworkAgent: '',
        FAgentExpressNo: '',
        FReceiveName: '',
        FReceiveMobile: '',
        FReceiveAddress: '',
        fAgentUrl: '',
        fAgentUrlShow: ''
      },
      componentCheckAll: false,
      isIndeterminate: false,
      dialogVisible: false,
      showPic: {
        fAgentUrl: ''
      },
      picLoadingArr: [{ fAgentUrlShow: false }],
      picMaxSize: 1024 * 3,
      checkLoading: false,
      addLoading: false,
      importReworkFile: '',
      importReworkFileName: '',
      rule_data: {
        FSn: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入机具编号'))
              } else {
                // if (!(/^\d{10,10}$/.test(value))) {
                //   callback(new Error('请输入10位机具编号'));
                // } else {
                callback()
                // }
              }
            },
            required: true,
            trigger: 'blur'
          }
        ],
        FReceiveName: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入真实姓名'))
              } else {
                if (/^[\u4e00-\u9fa5]{2,6}$/.test(value)) {
                  callback()
                } else {
                  callback(new Error('请输入2-6位中文姓名'))
                }
              }
            },
            required: true,
            trigger: 'blur'
          }
        ],
        FReceiveMobile: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(
                  new Error('请输入11位手机号码或“区号-”格式的座机号码')
                )
              } else {
                if (
                  !/^\d{11,11}$/.test(value) &&
                  !/0\d{2,3}-\d{7,8}/.test(value)
                ) {
                  callback(
                    new Error('请输入11位手机号码或“区号-”格式的座机号码')
                  )
                } else {
                  callback()
                }
              }
            },
            required: true,
            trigger: 'blur'
          }
        ],
        FReceiveAddress: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请填写寄回地址'))
              }
            },
            required: true
          }
        ],
        FAgentExpressNo: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请填写快递编号'))
              }
            },
            required: true
          }
        ],
        FReworkAgent: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请填写返修原因'))
              }
            },
            required: true
          }
        ]
      }
    }
  },
  methods: {
    /**
     * 返回配件全选点击
     */
    handleComponentCheckAllChange (value) {
      this.addForm.FComponents = value ? componentCheckOptions : []
      this.isIndeterminate = false
    },
    /**
     * 返回配件选择点击
     */
    handleComponentCheckedChange (value) {
      const checkedCount = value.length
      this.componentCheckAll = checkedCount === componentCheckOptions.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < componentCheckOptions.length
    },
    showBatch () {
      this.dialogVisible = true
    },
    submitExecel () {
      var strSrc = this.$jquery('#importOrder').val()
      var pos = strSrc.lastIndexOf('.')
      var lastname = strSrc.substring(pos, strSrc.length)
      var type = lastname.toLowerCase()
      if (type !== '.xlsx') {
        alert('请上传xlsx格式的文件')
        return false
      }
      this.$jquery('#importExpress').submit()
    },
    // 选择文件
    getFiles () {
      this.$jquery('#file').click()
    },
    getFile (event) {
      this.merchantExcel = event.target.files[0]
      this.merchantExcelName = this.merchantExcel.name
    },
    // 新增返修机具
    addSubmit (addForm) {
      var that = this
      var FComponents = this.addForm.FComponents

      console.log(FComponents.join(','))
      this.addForm.FComponents = FComponents.join(',')
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.addLoading = true
        let para = Object.assign({}, this.addForm)
        para = qs.stringify(para)
        addreworkMachine(para).then((data) => {
          this.addForm.FComponents = FComponents
          this.addLoading = false
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.$refs.addForm.resetFields()
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            // that.$refs['addForm'].resetFields();
          }
        },
        {
          errFn: (e) => {
            this.$message({
              showClose: true,
              message: e,
              type: 'error'
            })
            // that.$refs['addForm'].resetFields();
          }
        }
        )
      })
    },
    // 批量导入
    batchSubmit () {
      var that = this
      that.leadLoading = true
      var multipartFile = that.merchantExcel
      if (multipartFile === '') {
        this.$message({
          showClose: true,
          message: '请选择文件后导入',
          type: 'error'
        })
        that.leadLoading = false
        return false
      }
      var formData = new FormData()
      formData.append('multipartFile', multipartFile)
      // formData.append("credentialType",that.addForm.credentialType);
      batchAddRework(formData).then((data) => {
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
          that.leadLoading = false
          this.dialogVisible = false
        } else {
          that.$message({
            message: data.error_msg,
            type: 'error'
          })
          that.leadLoading = false
        }
      })
    },
    // 上传图片
    upload (param) {
      var that = this
      // var file = ''
      var picType = param
      var picFile = that.addForm[picType]
      var reader = new FileReader()
      that.picLoadingArr[picType] = true
      reader.readAsDataURL(picFile)
      reader.onload = function (e) {
        var file = this.result
        file = file.split('base64,')
        var data = {
          // merchantId : merchantId,
          base64pic: file[1],
          picType: picType
        }
        data = qs.stringify(data)
        uploadPic(data).then((data) => {
          that.picLoadingArr[picType] = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.addForm.fAgentUrl = data.path // 将绝对路径放到form表单中，存储到数据库中
            that.showPic[picType] = data.showPath // 将图片展示路径设置到引用中
            // 上传完成后本地存储
            that.storeToLocal()
          } else {
            that.addForm[picType] = ''
            that.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
        },
        {
          errFn: () => {
            that.picLoadingArr[picType] = false
            that.addForm.fAgentUrl = ''
            that.$message({
              showClose: true,
              message: '图片过大，请压缩后上传！',
              type: 'error'
            })
          }
        }
        )
      }
    },
    /**
     * 本地存储方法
     */
    storeToLocal () {
      const addInfo = {
        addForm: JSON.parse(JSON.stringify(this.addForm)),
        showPic: this.showPic
      }
      localStorage.setItem('MERCHANT_ADD_INFO', JSON.stringify(addInfo))
    }
  }
}
</script>
<style scoped rel="stylesheet/scss" lang="scss">
.demo-form-inline {
  display: inline-block;
  float: right;
}

.btm-action {
  margin-top: 20px;
  text-align: center;
}

.pagination {
  display: inline-block;
}
.list {
  padding-left: 20px;
}
.tab-tag {
  height: 0;
  padding: 0;
  line-height: 0;
  background: transparent;
}
.dsn {
  display: none;
}
.check {
  margin-left: 2%;
}
.form-input {
  width: 450px;
}
</style>
